import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=231456de"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231456de')) {
      api.createRecord('231456de', component.options)
    } else {
      api.reload('231456de', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=231456de", function () {
      api.rerender('231456de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChartNodeTypes/Modal.vue"
export default component.exports